export default {
  reports: {
    // ---- AI report error codes (backend `errorCode`) -> localized messages ----
    errors: {
      INSUFFICIENT_CREDITS:
        "No tiene suficientes créditos de IA para generar este informe. Póngase en contacto con su administrador.",
      REPORT_ACCESS_DENIED: "Este informe de IA no está habilitado para su cuenta.",
      NOT_FOUND: "No se pudo encontrar el informe solicitado.",
      INVALID_INPUT: "Algunos de los datos proporcionados no son válidos. Revíselos e inténtelo de nuevo.",
      INVALID_GEOMETRY: "El área seleccionada no es válida. Ajuste la geocerca e inténtelo de nuevo.",
    },
    gen: "Género",
    total: "Total",
    gender: "Tabla de género",
    male: "Masculino",
    female: "Femenino",
    other: "Otro",
    byCountry: "Por País",
    avgPriceFarmer: "Precio Promedio Pagado por Agricultor (Cacao)",
    avgPrice: "Precio Promedio",
    selectYear: "seleccionar año",
    farmerName: "Nombre del granjero",
    farmerProdChart: "Gráfico de producción del granjero",
    production: "Producción",
    byProduction: "Por producción",
    byName: "Por nombre",
    descending: "Descendiente",
    ascending: "Ascendiente",
    buyingStationProdChart: "Gráfico de producción de la central de compra",
    buyingStation: "Central de Compra",
    buyingStationName: "Nombre de la central de compra",
    dryMilling: "Molienda en seco",
    dryMillingName: "Nombre de la molienda en seco",
    dryMillingProdChart: "Gráfico de producción de la molienda en seco",
    view: "Vista",
    date: "Fecha",
    reports: "Informes",
    today: "Hoy",
    week: "Semana",
    month: "Mes",
    year: "Año",
    all: "Todo",
    selectCrop: "Seleccionar Cultivo",
    selectRegion: "Seleccionar Región",
    downloadPdfReport: "Descargar Informe en PDF",
    export: "Exportar",
    search: "Buscar",
    yield: "Rendimiento",
    pests: {
      pestReport: "Informe de Plagas",
      filterByCrops: "Filtrar por Cultivos",
      pestStatistics: "Estadísticas de Plagas",
      regions: "Regiones",
      occurrences: "Ocurrencias",
      pestChart: "Gráfico de Plagas",
      totalArea: "Área Total",
      pestName: "Nombre de la Plaga",
      region: "Región",
      crop: "Cultivos",
      listByLand: "Lista por Terreno",
    },
    regions: {
      regionalReport: "Informe Regional",
      listByFarm: "Listar por Finca",
      listByFarmers: "Listar por Agricultores",
      listByYield: "Listar por Rendimiento",
      regionalStatistics: "Estadísticas Regionales",
      countries: "Países",
      states: "Estados/Provincias",
      city: "Ciudad/Pueblo/Villa",
      farmsIn: "Fincas en",
      regionalChart: "Gráfico Regional",
      farms: "Fincas",
      regionName: "Nombre de la Región",
      farmers: "Agricultores",
      yield: "Rendimiento/Acre",
    },
    dashboard: {
      topCharts: "Principales Gráficos",
      regions: "Regiones",
      noOfFarms: "Núm. de Fincas/Región",
      provinces: "Provincias Estados",
      landArea: "Área de Tierra",
      avgFarmerLand: "Prom. de Tierra por Agricultor",
      viewAll: "Ver Todo",
      crops: "Cultivos",
      plantedAreaCrop: "Área Plantada/Cultivo",
      plantedArea: "Área Plantada",
      avgYieldCrop: "Rendimiento Promedio/Cultivo",
      averageYield: "Rendimiento Promedio",
      yieldChart: "Gráfico de Rendimiento",
      selectFarm: "Seleccionar Finca",
      soilQuality: "Calidad del Suelo",
      pests: "Plagas",
      occurrences: "Ocurrencias",
      equipments: "Equipos",
      goalAchievedChart: "Gráfico de Metas Alcanzadas",
      soilValues: "Valores del Suelo",
      soil: "Suelo",
      showReport: "Mostrar Informes en el Panel de Control",
      selectAll: "Seleccionar Todo",
    },
    weight: "Peso",
    quality: "Calidad",
    price: "Precio",

    yieldPrediction: "Predicción de Rendimiento",
    listOfReports: "Lista de Informes",
    noYieldPredictionReportsFound: "No se encontraron informes de predicción de rendimiento",
    loadingYieldPredictions: "Cargando predicciones de rendimiento...",
    createNewReport: "Crear Nuevo Informe",

    howToUseReport: "¿Cómo usar el informe?",
    viewGuide: "Ver guía",
    generateReport: "Generar Informe",
    selectFarmGeofence: "Seleccionar Geocerca de la Finca",
    selectFarmGeofenceDescription: "Seleccione una finca registrada, dibuje el límite de su finca en el mapa o introduzca una ubicación para comenzar a analizar la predicción de rendimiento del área de la finca.",
    point: "Punto",
    geofence: "Geocerca",
    selectFarmZone: "Seleccionar Finca/Zona",
    select: "Seleccionar",
    latitude: "Latitud",
    longitude: "Longitud",
    uploadGeojsonFile: "Subir Archivo GeoJSON",
    uploadGeojsonFileDescription: "Seleccione un archivo GeoJSON con su geocerca desde su computadora y súbalo. Solo se subirá una geocerca a la vez, incluso si su archivo tiene varias geocercas.",
    selectAFile: "Seleccionar Un Archivo",
    hideAdvanced: "Ocultar Avanzado",
    showAdvancedVariation: "Mostrar Variación Avanzada",
    uploadHistoricalYieldDataDescription: "Por favor, suba los datos históricos de rendimiento de su finca",
    showInstructions: "Mostrar Instrucciones",
    downloadTemplate: "Descargar Plantilla",
    chooseFile: "Elegir Archivo",
    noFileSelected: "Ningún archivo seleccionado",
    yieldPredictionGuide: "Guía de Predicción de Rendimiento",
    forecastedYields: "Rendimientos Pronosticados",
    farmArea: "Área de la Finca",
    yieldForecasts: "Pronósticos de Rendimiento",
    graph: "Gráfico",
    actualYields: "Rendimientos Reales",
    predictedFutureYields: "Rendimientos Futuros Previstos",
    averageYields: "Rendimientos Promedio",
    yieldTrendsGraph: "Gráfico de Tendencias de Rendimiento",
    step1: "Paso 1",
    step2: "Paso 2",
    step3: "Paso 3",
    step4: "Paso 4",
    satelliteMapView: "Vista del Mapa Satelital",
    selectYourFarm: "Seleccione su finca del menú desplegable (si ya está registrada).",
    selectCropType: "Seleccione un tipo de cultivo:",
    clickGenerateReport: "Haga clic en 'Generar Informe' para ver su informe de predicción de rendimiento.",
    howToGenerateReport: "¿Cómo Generar un Informe?",
    howToInterpretReport: "¿Cómo Interpretar el Informe?",
    tip: "Consejo",

    disclaimer: "Aviso Legal",
    disclaimer1: "Es imposible predecir con precisión el clima para toda una temporada. Por ejemplo, el granizo o las inundaciones pueden ocurrir en cualquier momento, lo que puede afectar significativamente las predicciones de rendimiento.",
    disclaimer2: "Los rendimientos dependen en gran medida de las prácticas de manejo del agricultor. Por ejemplo, la aplicación oportuna de pesticidas o el riego adecuado pueden afectar considerablemente el rendimiento final.",
    disclaimer3: "Existen otros factores que pueden contribuir a errores significativos en las predicciones de rendimiento por IA.",
    startYear: "Año de Inicio",
    endYear: "Año de Fin",
    back: "Atrás",
    deleteReport: "Eliminar Informe",
    confirmDeleteReport: "¿Está seguro de que desea eliminar este informe de predicción de rendimiento? Esta acción no se puede deshacer y todos los datos asociados se eliminarán de forma permanente.",
    deleteConfirmation: "Confirmación de Eliminación",
    download: "Descargar",
    report: "Informe",
    dateOfReport: "Fecha del Informe",
    farm: "Finca",
    location: "Ubicación",
    zone: "Zona",
    crop: "Cultivo",
    farmers: "Agricultores",
    yieldPerAcre: "Rendimiento/Acre",
    yieldPerHectare: "Rendimiento/Hectárea",
    predictionModel: "Modelo de Predicción",
    accuracy: "Exactitud (R²)",
    confidence: "Confianza",
    producer: "Productor",
    reportDeletedSuccessfully: "Informe eliminado correctamente",
    failedToDeleteReport: "Error al eliminar el informe",
    enterHere: "Introduzca aquí",
    hectares: "hectáreas",
    whatIsYieldReportTitle: "¿Qué es un Informe de Predicción de Rendimiento?",
    yieldReportDescription: "El Informe de Predicción de Rendimiento le ayuda a estimar los rendimientos de los cultivos de su finca utilizando datos históricos, datos satelitales y modelos predictivos basados en IA. El informe le ofrece una estimación de cuánto cultivo podría cosechar en el año actual y los próximos. El informe proporciona información sobre rendimientos reales, rendimientos futuros previstos y rendimientos promedio, permitiéndole optimizar sus operaciones agrícolas y planificar con antelación.",
    creatingYourReportEasy: "Crear su informe es fácil:",
    selectYourFarmDescription: "El límite aparecerá en el mapa. O bien, dibuje el límite de su finca (polígono o un punto) manualmente en el mapa si aún no está registrada. También puede buscar escribiendo la Latitud y Longitud para hacer zoom en una ubicación.",
    selectCropTypeDescription: "Elija el cultivo que desea analizar del menú desplegable.",
    clickGenerateReportDescription: "para ver su informe de predicción de rendimiento.",
    interpretReportIntro: "Una vez generado el informe, verá los pronósticos de rendimiento para el año actual y el próximo. Un gráfico muestra las tendencias de rendimiento de su finca con tres líneas:",
    blueLineActualYields: "Línea Azul (Rendimientos Reales):",
    blueLineDescription: "Representa los resultados reales de cosechas de temporadas anteriores en su finca. Esto le ayuda a comprender las tendencias de rendimiento pasadas a lo largo del tiempo.",
    redLinePredictedYields: "Línea Roja (Rendimientos Futuros Previstos):",
    redLineDescription: "Muestra los pronósticos basados en IA para los próximos rendimientos. Ofrece una estimación de lo que puede esperar (cuánto podría cosechar) basada en datos y tendencias actuales.",
    brownLineAverageYields: "Línea Marrón (Rendimientos Promedio):",
    brownLineDescription: "Indica el rendimiento promedio de todos los datos disponibles de la finca. Esta línea sirve como referencia para ayudarle a comparar los rendimientos históricos y previstos con la tendencia general.",
    highPredictedYieldsLabel: "Rendimientos previstos altos",
    highPredictedYieldsDescription: "sugieren que las prácticas actuales son efectivas. Mantenga sus estrategias e incluso replíquelas en otras áreas de su finca.",
    lowPredictedYieldsLabel: "Rendimientos previstos bajos",
    lowPredictedYieldsDescription: "pueden indicar áreas de mejora, como cronogramas de siembra, salud del suelo, uso de fertilizantes, riego, manejo de plagas, estrés hídrico o deficiencias de nutrientes, etc. Investigue y aborde estos problemas a tiempo para evitar mayores pérdidas de rendimiento.",
    tipDescription: "Puede guardar, descargar o eliminar sus informes para referencia futura.",
    validationError: "Error de Validación",
    pleaseSelectCrop: "Por favor seleccione un cultivo",
    pleaseEnterLatLng: "Por favor introduzca la latitud y longitud o seleccione un punto en el mapa",
    pleaseDrawGeofence: "Por favor dibuje una geocerca en el mapa o suba un archivo GeoJSON",
    invalidGeojsonFile: "Archivo GeoJSON inválido",
    invalidGeojsonFileDescription: "Por favor asegúrese de que el archivo tenga un formato GeoJSON válido.",
    errorReadingFile: "Error al leer el archivo",
    failedToReadGeojson: "No se pudo leer el archivo GeoJSON. Por favor inténtelo de nuevo.",
    yieldReportGeneratedSuccessfully: "Informe de predicción de rendimiento generado con éxito",
    failedToGenerateReport: "Error al generar el informe. Por favor inténtelo de nuevo.",
    farmAndFarmId: "Finca e ID de Finca",
    producerName: "Nombre del Productor",
    failedToLoadReport: "Error al cargar el informe de predicción de rendimiento",
    reportDataNotLoaded: "Los datos del informe no se han cargado. Por favor espere e inténtelo de nuevo.",
    pdfGeneratedSuccessfully: "PDF generado con éxito",
    failedToGeneratePdf: "Error al generar el PDF. Por favor inténtelo de nuevo.",
    editMap: "Editar Mapa",
    editMapDescription: "La funcionalidad de edición del mapa se implementará aquí",
    noForecastDataAvailable: "No hay datos de pronóstico disponibles",
    noGraphImageAvailable: "No hay imagen de gráfico disponible",
// Shared AI report redesign
    landSuitability: "Land Suitability",
    aiReportGuide: "AI Report Guide",
    aiReportsDashboard: "Panel de Informes de IA",
    aiReports: "Informes de IA",
    dashboardGuide: "Guía del panel",
    aiReportBuilders: "Generadores de informes de IA",
    aiInsightsAndAnalytics: "Insights y analítica de IA",
    reportTypeDistribution: "Distribución por tipo de informe",
    reportType: "Tipo de informe",
    reportsGenerated: "Informes generados",
    recentAiReports: "Informes de IA recientes",
    vegetationVigorAnalysis: "Análisis de vigor vegetativo",
    farmProductivityAnalysis: "Análisis de productividad de finca",
    anomaliesDetection: "Detección de anomalías",
    diseaseDetection: "Detección de enfermedades",
    averageVegetationHealth: "Salud vegetativa promedio",
    diseaseDetectedThisMonth: "Enfermedades detectadas este mes",
    anomaliesThisMonth: "Anomalías este mes",
    predictedYieldTrend: "Tendencia de rendimiento prevista",
    comingSoon: "Próximamente",
    reportBuilderComingSoon: "Este generador de informes de IA estará disponible pronto.",
    loadingRecentReports: "Cargando informes recientes…",
    noRecentAiReports: "No se encontraron informes de IA recientes.",
    backToDashboard: "Back to dashboard",
    reportsBreadcrumb: "Reports",
    customizeTable: "Customize table",
    customization: "Customization",
    recordsPerPage: "Records per page",
    visibleColumns: "Visible columns",
    restoreDefault: "Restore default",
    apply: "Apply",
    reportId: "Report ID",
    viewReport: "View report",
    noLandSuitabilityReportsFound: "No Land Suitability reports found.",
    confirmDeleteLandSuitabilityReport: "Are you sure you want to delete this Land Suitability report?",
    landSuitabilityReportDeletedSuccessfully: "Land Suitability report deleted successfully.",
    unableToDeleteReport: "Unable to delete the report.",
    unableToDeleteReportRetry: "Unable to delete the report. Please try again.",
    of: "of",
    estimatedComputeCost: "Estimated Compute Cost",
    totalCreditsRequired: "Total Credits Required",
    creditsAvailable: "Credits Available",
    status: "Status",
    credits: "Credits",
    creditsSufficient: "Credits Sufficient for AI Report Generation",
    insufficientCredits: "Insufficient Credits",
    selectFarm: "Select Farm",
    showAdvanced: "Show advanced",
    sourceFarmZone: "Finca / zona",
    sourcePolygon: "Polígono",
    sourceCircle: "Círculo",
    sourceGeojson: "GeoJSON",
    radiusM: "Radio (m)",
    drawPolygon: "Dibujar polígono",
    drawPolygonHelp: "Haga clic en el mapa para agregar puntos.",
    drawCircle: "Dibujar círculo",
    drawCircleHelp: "Haga clic en el mapa para fijar el centro; ajuste el radio abajo o arrastre el círculo para redimensionarlo.",
    drawingHintPoint: "Click the map to place a point. Drag the marker to adjust it.",
    drawingHintGeofence: "Click at least three locations to draw the geofence. Drag points to adjust it.",
    drawingHintPointShort: "Click the map to place or move the point",
    drawingHintGeofenceShort: "Click at least three locations to draw the farm boundary",
    undoLastGeofencePoint: "Undo last geofence point",
    undoLastPoint: "Undo last point",
    clearGeofence: "Clear geofence",
    previousImage: "Previous image",
    nextImage: "Next image",
    selectDate: "Select Date",
    reportDetails: "Report Details",
    greenAreas: "Green Areas",
    yellowAreas: "Yellow Areas",
    redAreas: "Red Areas",
    greenAreasDescription: "Current vegetation vigor outperforms historical average",
    yellowAreasDescription: "Current vegetation vigor performs according to historical average",
    redAreasDescription: "Areas with poor crop performance that require immediate attention",
    underperforming: "Underperforming",
    outperforming: "Outperforming",
    landSuitabilityDisclaimer: "This AI-generated report is intended to serve as a guide. For accurate diagnosis and tailored recommendations, consult a qualified agronomist or agricultural expert.",
    startDate: "Start Date",
    numberOfHistoricalReports: "Number of Historical Reports",
    compareReports: "Compare reports",
    satelliteImageryNote: "Satellite imagery for the exact report date may not be available. The closest available satellite layer is shown instead.",
    farmLocation: "Farm location",
    feedback: "Feedback",
    feedbackColon: "Feedback:",
    agreedWithPrediction: "Agreed with Prediction",
    predictionNotAccurate: "Prediction Not Accurate",
    attachments: "Attachments",
    noAttachmentsAdded: "No attachments added",
    doYouAgreeWithPrediction: "Do you agree with the prediction?",
    agree: "Agree",
    disagree: "Disagree",
    agreeWithPrediction: "Agree with prediction",
    disagreeWithPrediction: "Disagree with prediction",
    feedbackDisagreementPlaceholder: "Tell us what does not reflect the current reality of the field",
    addAttachments: "Add attachments",
    removeAttachment: "Remove attachment",
    submitFeedback: "Submit feedback",
    loadingFeedback: "Loading feedback",
    attachment: "Attachment",
    unableToLoadAvailableCrops: "Unable to load available crops.",
    unableToGenerateReport: "Unable to generate the report.",
    unableToLoadLandSuitabilityReport: "Unable to load the Land Suitability report.",
    unableToDownloadReport: "Unable to download the report.",
    pleaseSelectValidGeojson: "Please select a valid Polygon or MultiPolygon GeoJSON file.",
    historicalComparisonUnavailable: "Historical comparison is not available from the current report API.",
    unableToLoadFeedback: "Unable to load feedback.",
    unableToLoadReportFeedback: "Unable to load report feedback.",
    attachmentTypeSizeLimit: "Attachments must be images or videos no larger than 10 MB.",
    unableToSubmitFeedback: "Unable to submit feedback.",
    feedbackSubmittedSuccessfully: "Feedback submitted successfully.",
    unableToSubmitFeedbackRetry: "Unable to submit feedback. Please try again.",
    openReportToViewGuide: "Open a report to view the complete AI report guide.",
    downloadReport: "Download report",
    pleaseSelectPointOnMap: "Please select a point on the map",
    pleaseDrawPolygonMinPoints: "Please draw a polygon with at least 3 points",
    // ---- Farm Productivity / Productivity Zones Analysis ----
    farmProductivity: {
      title: "Análisis de productividad de la finca",
      listOfReports: "Lista de informes",
      createNewReport: "Crear nuevo informe",
      backToDashboard: "Volver al panel",
      generateReport: "Generar informe",
      cancel: "Cancelar",
      back: "Volver",
      deleteReport: "Eliminar informe",
      downloadReport: "Descargar informe",
      aiReportGuide: "GuÃ­a del informe de IA",
      viewGuide: "Ver guía",
      howToUseReport: "¿Cómo usar el informe?",
      search: "Buscar",
      reportId: "ID del informe",
      farmAndFarmId: "Finca e ID de finca",
      producerName: "Nombre del productor",
      dateOfReport: "Fecha del informe",
      status: "Estado",
      statusCompleted: "Completado",
      statusGenerating: "Generando",
      statusFailed: "Fallido",
      location: "UbicaciÃ³n",
      farm: "Finca",
      zone: "Zona",
      actions: "Acciones",
      view: "Ver",
      delete: "Eliminar",
      selectFarmGeofence: "Seleccionar geocerca de la finca",
      selectFarmGeofenceHelp: "Seleccione una finca registrada, dibuje el límite en el mapa o cargue un archivo GeoJSON.",
      selectFarmZone: "Seleccionar finca / zona",
      sourceFarmZone: "Finca / zona",
      sourcePolygon: "PolÃ­gono",
      sourceCircle: "CÃ­rculo",
      sourceGeojson: "GeoJSON",
      radiusM: "Radio (m)",
      select: "Seleccionar",
      uploadGeojsonFile: "Subir archivo GeoJSON",
      uploadGeojsonHelp: "Seleccione un archivo GeoJSON con su geocerca desde su computadora y cÃ¡rguelo. Solo se cargarÃ¡ una geocerca a la vez, aunque el archivo tenga varias.",
      selectAFile: "Seleccionar un archivo",
      drawPolygon: "Dibujar polÃ­gono",
      drawPolygonHelp: "Haga clic en el mapa para agregar puntos.",
      drawCircle: "Dibujar cÃ­rculo",
      drawCircleHelp: "Haga clic en el mapa para fijar el centro; ajuste el radio abajo o arrastre el cÃ­rculo para redimensionarlo.",
      estimatedComputeCost: "Costo de cómputo estimado",
      totalCreditsRequired: "Total de créditos requeridos",
      creditsComingSoon: "El sistema de créditos estará disponible pronto.",
      reportDetails: "Detalles del informe",
      generating: "Generando informe...",
      generatingHelp: "Su informe se está generando. Esto puede tardar unos minutos.",
      failed: "Error al generar el informe.",
      reportDescription: "El informe de zonas de productividad analiza la productividad del área de su finca según el rendimiento histórico y los indicadores de vegetación.",
      disclaimerTitle: "AVISO",
      disclaimer: "Este informe generado por IA estÃ¡ pensado como guÃ­a. Para un diagnÃ³stico preciso y recomendaciones personalizadas, le recomendamos consultar a un agrÃ³nomo o experto agrÃ­cola calificado.",
      zoneLabels: {
        "Lowest Productivity Zones": "Zonas de productividad más baja",
        "Low Productivity Zones": "Zonas de baja productividad",
        "Moderate Productivity Zones": "Zonas de productividad moderada",
        "High Productivity Zones": "Zonas de alta productividad",
        "Highest Productivity Zones": "Zonas de productividad más alta",
      },
      zoneDesc: {
        "Lowest Productivity Zones": "Áreas con el peor rendimiento de cultivos que requieren atención o intervención inmediata.",
        "Low Productivity Zones": "Áreas con rendimiento por debajo del promedio que necesitan mejoras.",
        "Moderate Productivity Zones": "Áreas con rendimiento moderado que pueden necesitar algunos ajustes.",
        "High Productivity Zones": "Áreas con rendimiento por encima del promedio y buen potencial de producción.",
        "Highest Productivity Zones": "Áreas con rendimiento óptimo y el mayor potencial de producción.",
      },
      feedback: "Comentarios",
      doYouAgree: "¿Está de acuerdo con la predicción?",
      agree: "De acuerdo",
      disagree: "En desacuerdo",
      agreedWithPrediction: "De acuerdo con la predicción",
      disagreedWithPrediction: "En desacuerdo con la predicción",
      disagreeHelp: "Si no está de acuerdo con este resultado, proporcione su comentario",
      addFeedback: "Agregar comentarios",
      feedbackPlaceholder: "Ingrese aquÃ­",
      attachmentsOptional: "Adjuntos (opcional)",
      attachments: "Adjuntos",
      download: "Descargar",
      attachmentsHelp: "Arrastre y suelte imÃ¡genes o videos aquÃ­, o explore archivos. Formatos admitidos: JPG, PNG, MP4.",
      selectFilesToUpload: "Seleccione archivos para cargar los datos",
      orDragAndDrop: "o arrastre y suelte aquÃ­",
      submit: "Enviar",
      feedbackSubmitted: "Comentarios enviados correctamente.",
      feedbackAlreadySubmitted: "Ya se enviaron comentarios para este informe.",
      guideTitle: "Guía de zonas de productividad",
      guideStep: "Paso {current} de {total}",
      next: "Siguiente",
      close: "Cerrar",
      guideStep1Title: "¿Qué es el informe de zonas de productividad?",
      guideStep1Body: "El informe de zonas de productividad analiza la productividad de las áreas dentro de su zona o finca y las clasifica en zonas de bajo, moderado y alto rendimiento.",
      guideStep2Title: "¿Cómo generar un informe?",
      guideStep2Body: "Crear su informe es fácil:\n\n1. Seleccione su finca en el menú desplegable (si está registrada) o dibuje/cargue el límite.\n2. Genere el informe y espere a que se complete el análisis.",
      guideStep3Title: "¿Cómo interpretar el informe?",
      guideStep3Body: "Una vez generado, el informe muestra un mapa codificado por colores que divide su finca en tres zonas de productividad.",
      guideTip: "Consejo:",
      guideTipBody: "Comience por las zonas naranjas: necesitan las mejoras más urgentes. Estudie las zonas verdes para replicar buenas prácticas.",
      invalidGeojsonFile: "Archivo GeoJSON no vÃ¡lido",
      invalidGeojsonFileDescription: "El archivo seleccionado no es un GeoJSON vÃ¡lido. RevÃ­selo e intÃ©ntelo de nuevo.",
      generateFailed: "No se pudo iniciar la generaciÃ³n del informe. IntÃ©ntelo de nuevo.",
      loadFailed: "No se pudo cargar el informe. IntÃ©ntelo de nuevo.",
      deleteConfirmTitle: "Eliminar informe",
      deleteConfirmMessage: "Â¿Seguro que desea eliminar este informe? Esta acciÃ³n no se puede deshacer.",
      deleted: "Informe eliminado correctamente.",
      uploadFailed: "Error al cargar el archivo. IntÃ©ntelo de nuevo.",
    },

    // ---- Anomaly Detection ----
    anomalyDetection: {
      title: "Detección de anomalías",
      reportComparison: "Comparación de informes",
      listOfReports: "Lista de informes",
      createNewReport: "Crear nuevo informe",
      backToDashboard: "Volver al panel",
      generateReport: "Generar informe",
      cancel: "Cancelar",
      back: "Volver",
      deleteReport: "Eliminar informe",
      downloadReport: "Descargar informe",
      compareReports: "Comparar informes",
      aiReportGuide: "GuÃ­a del informe de IA",
      search: "Buscar",
      reportId: "ID del informe",
      farmAndFarmId: "Finca e ID de finca",
      producerName: "Nombre del productor",
      dateOfReport: "Fecha del informe",
      status: "Estado",
      statusCompleted: "Completado",
      statusGenerating: "Generando",
      statusPartial: "Parcial",
      statusFailed: "Fallido",
      location: "UbicaciÃ³n",
      farm: "Finca",
      zone: "Zona",
      actions: "Acciones",
      view: "Ver",
      delete: "Eliminar",
      selectFarmGeofence: "Seleccionar geocerca de la finca",
      selectFarmGeofenceHelp: "Seleccione una finca registrada, dibuje el límite en el mapa o cargue un archivo GeoJSON.",
      selectFarmZone: "Seleccionar finca / zona",
      sourceFarmZone: "Finca / zona",
      sourcePolygon: "PolÃ­gono",
      sourceCircle: "CÃ­rculo",
      sourceGeojson: "GeoJSON",
      radiusM: "Radio (m)",
      select: "Seleccionar",
      uploadGeojsonFile: "Subir archivo GeoJSON",
      uploadGeojsonHelp: "Seleccione un archivo GeoJSON con su geocerca desde su computadora y cÃ¡rguelo. Solo se cargarÃ¡ una geocerca a la vez, aunque el archivo tenga varias.",
      selectAFile: "Seleccionar un archivo",
      drawPolygon: "Dibujar polÃ­gono",
      drawPolygonHelp: "Haga clic en el mapa para agregar puntos.",
      drawCircle: "Dibujar cÃ­rculo",
      drawCircleHelp: "Haga clic en el mapa para fijar el centro; ajuste el radio abajo o arrastre el cÃ­rculo para redimensionarlo.",
      detectAnomalies: "Detectar anomalías",
      detectAnomaliesHelp: "Después de dibujar o cargar una geocerca, seleccione la fecha de interés para detectar anomalías.",
      startDate: "Fecha de inicio",
      fetchingDates: "Obteniendo fechas disponibles...",
      noAvailableDates: "No hay fechas satelitales disponibles para esta área.",
      selectDateToGenerate: "Seleccione una fecha disponible y luego genere el informe.",
      numberOfHistoricalReports: "Número de informes históricos",
      historicalReportsPlaceholder: "Ingrese aquí",
      historicalReportsNote: "Aumentar este número consumirá créditos de IA adicionales por cada imagen histórica solicitada.",
      estimatedComputeCost: "Costo de cómputo estimado",
      totalCreditsRequired: "Total de créditos requeridos",
      creditsComingSoon: "El sistema de créditos estará disponible pronto.",
      selectDate: "Seleccionar fecha",
      reportDetails: "Detalles del informe",
      closestImageNote: "No había imágenes satelitales para {requested}. Usamos la imagen disponible más cercana.",
      generating: "Generando informe...",
      generatingHelp: "Su informe se está generando. Esto puede tardar unos minutos.",
      partialWarning: "Algunas fechas no se pudieron generar para este informe.",
      failed: "Error al generar el informe.",
      disclaimerTitle: "AVISO",
      disclaimer: "Este informe generado por IA estÃ¡ pensado como guÃ­a. Para un diagnÃ³stico preciso y recomendaciones personalizadas, le recomendamos consultar a un agrÃ³nomo o experto agrÃ­cola calificado.",
      greenAreas: "Áreas verdes",
      greenAreasDesc: "El vigor vegetativo actual supera el promedio histórico",
      yellowAreas: "Áreas amarillas",
      yellowAreasDesc: "El vigor vegetativo actual se comporta según el promedio histórico",
      redAreas: "Áreas rojas",
      redAreasDesc: "Áreas con bajo rendimiento de cultivos que requieren atención o intervención inmediata.",
      underperforming: "Rendimiento inferior",
      outperforming: "Rendimiento superior",
      imageComparison: "Comparación de informes",
      sideComparison: "Comparación lado a lado",
      sliderComparison: "Comparación con deslizador",
      transparencyComparison: "Comparación de transparencia",
      transparencySlider: "Control de transparencia",
      notGeneratedPrompt: "Este informe aún no se ha generado para la fecha seleccionada. ¿Generarlo ahora?",
      generateNow: "Generar ahora",
      feedback: "Comentarios",
      doYouAgree: "¿Está de acuerdo con la predicción?",
      agree: "De acuerdo",
      disagree: "En desacuerdo",
      agreedWithPrediction: "De acuerdo con la predicción",
      disagreedWithPrediction: "En desacuerdo con la predicción",
      disagreeHelp: "Si no está de acuerdo con este resultado, proporcione su comentario",
      addFeedback: "Agregar comentarios",
      feedbackPlaceholder: "Ingrese aquÃ­",
      attachmentsOptional: "Adjuntos (opcional)",
      attachments: "Adjuntos",
      download: "Descargar",
      attachmentsHelp: "Arrastre y suelte imÃ¡genes o videos aquÃ­, o explore archivos. Formatos admitidos: JPG, PNG, MP4.",
      selectFilesToUpload: "Seleccione archivos para cargar los datos",
      orDragAndDrop: "o arrastre y suelte aquÃ­",
      submit: "Enviar",
      feedbackSubmitted: "Comentarios enviados correctamente.",
      feedbackAlreadySubmitted: "Ya se enviaron comentarios para este informe.",
      guideTitle: "Guía de detección de anomalías",
      guideStep: "Paso {current} de {total}",
      next: "Siguiente",
      close: "Cerrar",
      guideStep1Title: "¿Qué es la detección de anomalías?",
      guideStep1Body: "La detección de anomalías compara el rendimiento vegetativo actual de su campo con su promedio histórico para identificar áreas que rinden por encima o por debajo de lo esperado.",
      guideStep2Title: "¿Cómo generar un informe?",
      guideStep2Body: "Crear su informe es fácil:\n\n1. Seleccione su finca en el menú desplegable (si ya está registrada) o dibuje/cargue el límite.\n2. Elija una fecha disponible y genere el informe.",
      guideStep3Title: "¿Cómo interpretar el informe?",
      guideStep3Body: "Una vez generado, el informe muestra un mapa de calor codificado por colores según cómo el vigor actual se compara con el historial.",
      guideTip: "Consejo:",
      guideTipBody: "Comparación de fechas: el informe ofrece mapas de calor para varias fechas, lo que le permite seguir el cambio a lo largo del tiempo.",
      invalidGeojsonFile: "Archivo GeoJSON no vÃ¡lido",
      invalidGeojsonFileDescription: "El archivo seleccionado no es un GeoJSON vÃ¡lido. RevÃ­selo e intÃ©ntelo de nuevo.",
      geofenceRequired: "Seleccione una finca/zona, dibuje una geocerca o cargue un GeoJSON.",
      dateRequired: "Seleccione una fecha disponible.",
      generateFailed: "No se pudo iniciar la generaciÃ³n del informe. IntÃ©ntelo de nuevo.",
      loadFailed: "No se pudo cargar el informe. IntÃ©ntelo de nuevo.",
      datesFailed: "No se pudieron obtener las fechas disponibles. Inténtelo de nuevo.",
      deleteConfirmTitle: "Eliminar informe",
      deleteConfirmMessage: "Â¿Seguro que desea eliminar este informe? Esta acciÃ³n no se puede deshacer.",
      deleted: "Informe eliminado correctamente.",
      uploadFailed: "Error al cargar el archivo. IntÃ©ntelo de nuevo.",
    },

        yieldPredictionDesign: {
      disclaimerTitle: "DESCARGO DE RESPONSABILIDAD",
      disclaimerIntro: "In our yield predictions, the uncertainty may be 100% because there are many factors that are beyond our control, including:",
      disclaimer1: "It is impossible to accurately predict the weather for a whole season, so in some cases farmers could lose all their harvest due to just one hail event or flooding (especially now that global warming is often causing all these irregularities).",
      disclaimer2: "Yields are highly dependent on the management practices of farmers. For example, if they fail to spray pesticides at the right time, or irrigate properly, then yields will be very different from the predictions - this is also beyond our control.",
      disclaimer3: "There are many other factors like the above that may contribute to significant errors in the AI yield predictions.",
      disclaimer4: "If the farmer provides historical yields (ADVANCED mode), then predictions tend to be more accurate than the default (non-ADVANCED mode) predictions.",
      // feedback (shared FeedbackDisplay / FeedbackDialog)

      feedback: "Comentarios",
      doYouAgree: "¿Está de acuerdo con la predicción?",
      agree: "De acuerdo",
      disagree: "En desacuerdo",
      agreedWithPrediction: "De acuerdo con la predicción",
      disagreedWithPrediction: "En desacuerdo con la predicción",
      disagreeHelp: "Si no está de acuerdo con este resultado, proporcione su comentario",
      addFeedback: "Agregar comentarios",
      feedbackPlaceholder: "Ingrese aquí",
      attachmentsOptional: "Adjuntos (opcional)",
      attachments: "Adjuntos",
      download: "Descargar",
      attachmentsHelp: "Arrastre y suelte imágenes o videos aquí, o explore archivos. Formatos admitidos: JPG, PNG, MP4.",
      selectFilesToUpload: "Seleccione archivos para cargar los datos",
      orDragAndDrop: "o arrastre y suelte aquí",
      submit: "Enviar",
      feedbackSubmitted: "Comentarios enviados correctamente.",
      feedbackAlreadySubmitted: "Ya se enviaron comentarios para este informe.",
      uploadFailed: "Error al cargar el archivo. Inténtelo de nuevo.",
    },

landSuitabilityDesign: {
      reportDetails: "Detalles del informe",
      greenAreas: "Áreas verdes",
      greenAreasDesc: "Áreas calificadas como altamente adecuadas para el cultivo seleccionado",
      yellowAreas: "Áreas amarillas",
      yellowAreasDesc: "Áreas con idoneidad moderada que pueden necesitar atención",
      redAreas: "Áreas rojas",
      redAreasDesc: "Áreas calificadas como inadecuadas y que probablemente requieren intervención",
      underperforming: "Rendimiento inferior",
      outperforming: "Rendimiento superior",
      feedback: "Comentarios",
      doYouAgree: "¿Está de acuerdo con la predicción?",
      agree: "De acuerdo",
      disagree: "En desacuerdo",
      agreedWithPrediction: "De acuerdo con la predicción",
      disagreedWithPrediction: "En desacuerdo con la predicción",
      disagreeHelp: "Si no está de acuerdo con este resultado, proporcione su comentario",
      addFeedback: "Agregar comentarios",
      feedbackPlaceholder: "Ingrese aquí",
      attachmentsOptional: "Adjuntos (opcional)",
      attachments: "Adjuntos",
      download: "Descargar",
      attachmentsHelp: "Arrastre y suelte imágenes o videos aquí, o explore archivos. Formatos admitidos: JPG, PNG, MP4.",
      selectFilesToUpload: "Seleccione archivos para cargar los datos",
      orDragAndDrop: "o arrastre y suelte aquí",
      submit: "Enviar",
      feedbackSubmitted: "Comentarios enviados correctamente.",
      feedbackAlreadySubmitted: "Ya se enviaron comentarios para este informe.",
      uploadFailed: "Error al cargar el archivo. Inténtelo de nuevo.",
    },
    cropProgression: {
      title: "Análisis del vigor de la vegetación",
      listOfReports: "Lista de informes",
      createNewReport: "Crear nuevo informe",
      backToDashboard: "Volver al panel",
      generateReport: "Generar informe",
      cancel: "Cancelar",
      back: "Volver",
      deleteReport: "Eliminar informe",
      downloadReport: "Descargar informe",
      compareImages: "Comparar imágenes",
      aiReportGuide: "Guía del informe de IA",
      search: "Buscar",
      reportId: "ID del informe",
      farmAndFarmId: "Finca e ID de finca",
      producerName: "Nombre del productor",
      dateOfReport: "Fecha del informe",
      selectedDate: "Fecha del reporte",
      status: "Estado",
      statusCompleted: "Completado",
      statusGenerating: "Generando",
      statusPartial: "Parcial",
      statusFailed: "Fallido",
      location: "Ubicación",
      farm: "Finca",
      zone: "Zona",
      actions: "Acciones",
      view: "Ver",
      delete: "Eliminar",
      selectFarmGeofence: "Seleccionar geocerca de la finca",
      selectFarmGeofenceHelp: "Seleccione una finca registrada, dibuje el límite en el mapa o cargue un GeoJSON para comenzar a analizar su área.",
      point: "Punto",
      geofence: "Geocerca",
      selectFarmZone: "Seleccionar finca / zona",
      sourceFarmZone: "Finca / zona",
      sourcePolygon: "Polígono",
      sourceCircle: "Círculo",
      sourceGeojson: "GeoJSON",
      mapView: "Vista del mapa",
      latitude: "Latitud",
      longitude: "Longitud",
      radiusKm: "Radio (km)",
      radiusM: "Radio (m)",
      enterHere: "Ingrese aquí",
      select: "Seleccionar",
      uploadGeojsonFile: "Subir archivo GeoJSON",
      uploadGeojsonHelp: "Seleccione un archivo GeoJSON con su geocerca desde su computadora y cárguelo. Solo se cargará una geocerca a la vez, aunque el archivo tenga varias.",
      selectAFile: "Seleccionar un archivo",
      drawPolygon: "Dibujar polígono",
      drawPolygonHelp: "Haga clic en el mapa para agregar puntos.",
      drawCircle: "Dibujar círculo",
      drawCircleHelp: "Haga clic en el mapa para fijar el centro; ajuste el radio abajo o arrastre el círculo para redimensionarlo.",
      clearDrawing: "Borrar",
      searchLocation: "Buscar ubicación",
      closePolygonHint: "Haga clic en el primer punto para cerrar el área",
      unnamedFarm: "Finca #{id}",
      unnamedZone: "Zona #{id}",
      selectDate: "Seleccionar fecha",
      availableDates: "Fechas disponibles",
      fetchingDates: "Obteniendo fechas disponibles...",
      noAvailableDates: "No hay fechas satelitales disponibles para esta área.",
      selectDateToGenerate: "Seleccione una fecha disponible y luego genere el informe.",
      estimatedComputeCost: "Costo estimado de cómputo",
      totalCreditsRequired: "Créditos totales requeridos",
      creditsAvailable: "Créditos disponibles",
      creditsSufficient: "Créditos suficientes para generar el informe de IA",
      reportType: "Tipo de informe",
      selectReportType: "Seleccionar tipo de informe",
      chooseIndexHelp: "Elija un índice satelital para analizar el crecimiento, la humedad o los nutrientes de su cultivo a lo largo del tiempo.",
      scale: "Escala",
      generating: "Generando informe...",
      generatingHelp: "Su informe se está generando. Esto puede tardar unos minutos.",
      partialWarning: "Algunos índices no se pudieron generar para esta fecha.",
      failed: "La generación del informe falló.",
      valuesCloseToOne: "Los valores cercanos a 1 indican una vegetación más saludable",
      disclaimerTitle: "AVISO",
      disclaimer: "Este informe generado por IA está pensado como guía. Para un diagnóstico preciso y recomendaciones personalizadas, le recomendamos consultar a un agrónomo o experto agrícola calificado.",
      indexNDVI: "Salud del cultivo (NDVI)",
      indexMSAVI: "Crecimiento vegetativo temprano (MSAVI)",
      indexLSWI: "Contenido de humedad (LSWI)",
      indexRECI: "Estimación del nivel de nutrientes (RECI)",
      indexNDRE: "Verdor y densidad del dosel (NDRE)",
      reportComparison: "Comparación de informes de vigor de la vegetación",
      imageComparison: "Comparación de imágenes",
      sideComparison: "Comparación lado a lado",
      sliderComparison: "Comparación con control deslizante",
      transparencyComparison: "Comparación de transparencia",
      transparencySlider: "Control de transparencia",
      notGeneratedPrompt: "Este informe aún no se ha generado para la fecha seleccionada. ¿Generarlo ahora?",
      generateNow: "Generar ahora",
      feedback: "Comentarios",
      doYouAgree: "¿Está de acuerdo con la predicción?",
      agree: "De acuerdo",
      disagree: "En desacuerdo",
      agreedWithPrediction: "De acuerdo con la predicción",
      disagreedWithPrediction: "En desacuerdo con la predicción",
      disagreeHelp: "Si no está de acuerdo con este resultado, proporcione sus comentarios",
      addFeedback: "Agregar comentarios",
      feedbackPlaceholder: "Ingrese aquí",
      attachmentsOptional: "Adjuntos (opcional)",
      attachments: "Adjuntos",
      download: "Descargar",
      attachmentsHelp: "Arrastre y suelte imágenes o videos aquí, o explore archivos. Formatos admitidos: JPG, PNG, MP4.",
      selectFilesToUpload: "Seleccione archivos para cargar los datos",
      orDragAndDrop: "o arrastre y suelte aquí",
      submit: "Enviar",
      feedbackSubmitted: "Comentarios enviados correctamente.",
      feedbackAlreadySubmitted: "Ya se enviaron comentarios para este informe.",
      guideTitle: "Guía del análisis del vigor de la vegetación",
      guideStep: "Paso {current} de {total}",
      next: "Siguiente",
      close: "Cerrar",
      guideStep1Title: "¿Qué es el informe de análisis del vigor de la vegetación?",
      guideStep1Body: "Este análisis le ayuda a identificar áreas de su finca con bajo vigor vegetativo para actuar a tiempo. El informe usa imágenes satelitales para mostrar qué tan sanos están sus cultivos en un momento específico.\n\nEl mapa de calor muestra qué partes de su finca pueden necesitar atención. Al comparar imágenes de distintas fechas, puede seguir si sus cultivos mejoran o empeoran y ajustar sus prácticas.",
      guideStep2Title: "¿Cómo generar un informe?",
      guideStep2Body: "Crear su informe es fácil:\n\n1. Seleccione su finca en el menú desplegable (si ya está registrada). El límite aparecerá en el mapa. O dibuje el límite manualmente si aún no está registrada.\n2. Elija una fecha: es la fecha para la que desea ver los datos de vigor.\n3. Haga clic en \"Generar informe\" para ver su análisis.",
      guideStep3Title: "¿Cómo interpretar el informe?",
      guideStep3Body: "Una vez generado, verá un mapa de calor de su finca con colores verde, amarillo y rojo.\n\nVerde = Alto vigor vegetativo\nAmarillo/Rojo = Menor vigor → puede requerir atención\n\nEl bajo vigor puede deberse a la cosecha, suelo pobre, plagas o eventos climáticos recientes.",
      guideTip: "Consejo:",
      guideTipBody: "Use el selector de fechas bajo el mapa de calor para ver varios informes y seguir los cambios en la salud del cultivo. Puede guardar, descargar o eliminar sus informes en cualquier momento.",
      additionalReportTypes: "Tipos de informe adicionales disponibles:",
      invalidGeojsonFile: "Archivo GeoJSON no válido",
      invalidGeojsonFileDescription: "El archivo seleccionado no es un GeoJSON válido. Revíselo e inténtelo de nuevo.",
      geofenceRequired: "Seleccione una finca/zona, dibuje una geocerca o cargue un GeoJSON.",
      dateRequired: "Seleccione una fecha disponible.",
      generateFailed: "No se pudo iniciar la generación del informe. Inténtelo de nuevo.",
      loadFailed: "No se pudo cargar el informe. Inténtelo de nuevo.",
      datesFailed: "No se pudieron obtener las fechas disponibles. Inténtelo de nuevo.",
      deleteConfirmTitle: "Eliminar informe",
      deleteConfirmMessage: "¿Seguro que desea eliminar este informe? Esta acción no se puede deshacer.",
      deleted: "Informe eliminado correctamente.",
      uploadFailed: "Error al cargar el archivo. Inténtelo de nuevo.",
    },
    aiClient: {
      credits: "Créditos",
      cancel: "Cancelar",
      save: "Guardar",
      back: "Volver",
      close: "Cerrar",
      search: "Buscar",
      makeSelection: "Seleccione una opción",
      errorTitle: "Error",
      successTitle: "Éxito",
      loadFailed: "No se pudieron cargar los datos. Inténtelo de nuevo.",
      saveFailed: "No se pudo guardar. Inténtelo de nuevo.",
      saved: "Configuración guardada correctamente.",
      rt_vegetation_vigor: "Vigor de la vegetación",
      rt_farm_productivity: "Productividad de la finca",
      rt_anomaly_detection: "Detección de anomalías",
      rt_yield_prediction: "Predicción de rendimiento",
      rt_disease_detection: "Detección de enfermedades",
      rt_land_suitability: "Aptitud del suelo",
      dashTitle: "Panel de informes de IA",
      dashGuide: "Guía del panel",
      builders: "Generadores de informes de IA",
      distributionTitle: "Distribución por tipo de informe",
      colReportType: "Tipo de informe",
      colReportsGenerated: "Informes generados",
      recentTitle: "Informes de IA recientes",
      noRecent: "Aún no se han generado informes.",
      noDistribution: "Aún no hay actividad de informes.",
      na: "N/D",
      bVegetationVigor: "Análisis del vigor de la vegetación",
      bFarmProductivity: "Análisis de productividad de la finca",
      bAnomalies: "Detección de anomalías",
      bYield: "Predicción de rendimiento",
      bDisease: "Detección de enfermedades",
      bLand: "Aptitud del suelo",
      insightsTitle: "Información y analítica de IA",
      iVegHealth: "Salud vegetal promedio",
      iDisease: "Enfermedades detectadas este mes",
      iAnomalies: "Anomalías este mes",
      iYieldTrend: "Tendencia de rendimiento prevista",
      creditsAvailableLabel: "Disponibles",
      totalCredits: "Créditos totales:",
      creditsUsedLabel: "Créditos usados:",
      topUp: "Recargar créditos",
      topUpInfo: "Contacte a su administrador para recargar créditos.",
      creditsHistory: "Historial de créditos",
      manageBtn: "Administrar informes de IA y créditos",
      manageTitle: "Administrar informes de IA y créditos",
      usageLogBtn: "Registro de uso de créditos",
      cardAvailable: "Créditos disponibles",
      cardTotal: "Créditos totales",
      cardUsed: "Créditos usados",
      refreshesOn: "Se renueva el",
      assignedOn: "Asignado el",
      distBudgetTitle: "Distribución y presupuesto de informes de IA",
      distBudgetHelp: "Configure el acceso a informes de IA para sus uniones, fábricas y agricultores. Asigne presupuestos de créditos específicos a cada nivel para gestionar el consumo de recursos de su cooperativa de forma eficiente.",
      group_cooperative: "Cooperativa",
      group_buying_station: "Estación de compra",
      group_farmer: "Agricultor",
      monthlyCredits: "Créditos mensuales",
      aiReports: "Informes de IA",
      enabled: "Activado",
      disabled: "Desactivado",
      overAllocation: "Las asignaciones del grupo superan el presupuesto de créditos de la cooperativa.",
      usageLogTitle: "Registro de uso de créditos",
      filterCooperative: "Cooperativa",
      filterReport: "Informe de IA",
      colDateTime: "Fecha y hora",
      colEntity: "Entidad",
      colAiReport: "Informe de IA",
      colCreditsUsed: "Créditos usados",
      colBalance: "Saldo",
      historyTitle: "Historial de créditos",
      historyDesc: "Resumen de las asignaciones de créditos frente al consumo de esta cooperativa. Use este resumen para seguir las tendencias de uso mensual y los ciclos de facturación.",
      coopLabel: "Cooperativa",
      colMonth: "Mes",
      colCreditsAssigned: "Créditos asignados",
      colClosingBalance: "Saldo de cierre",
      noHistory: "Aún no hay historial de créditos.",
      guideTitle: "Guía del panel de informes de IA de Dimitra",
      guideStep: "Paso",
      guideOf: "de",
      guideClose: "Cerrar",
      guideSkip: "Omitir",
      guideNext: "Siguiente",
      guideBack: "Atrás",
      guideDone: "Cerrar",
      g1Title: "Resumen del panel",
      g1Intro: "Bienvenido a su centro de información de IA. Esta guía le ayudará a interpretar el mapa, gestionar sus créditos y usar los modelos de IA.",
      g1Points: [
        "Entienda la información del mapa: Use los filtros del mapa para ver provincias y regiones específicas. El mapa de calor ofrece una vista inmediata codificada por colores del rendimiento de las fincas en la cooperativa, con claves de indicadores Alto/Medio/Bajo.",
        "Supervise los créditos: Sus créditos disponibles actuales se muestran en la esquina superior derecha. Asegúrese de tener saldo suficiente antes de generar informes grandes.",
      ],
      g2Title: "Cómo entender los informes de IA",
      g2Intro: "Su panel ofrece acceso a modelos de IA especializados. Cada informe analiza distintos aspectos de sus datos agrícolas.",
      g2Points: [
        "Vigor de la vegetación: Evalúe la salud general del cultivo e identifique áreas que requieren atención.",
        "Productividad de la finca: Analice tendencias históricas de productividad para optimizar el potencial de rendimiento.",
        "Detección de anomalías: Detecte patrones irregulares en el campo que puedan indicar estrés o amenazas externas.",
        "Predicción de rendimiento: Pronostique resultados de cosecha según los datos de crecimiento actuales.",
        "Detección de enfermedades: Use imágenes de plantas para identificar enfermedades específicas al instante.",
      ],
      g3Title: "Cómo funcionan los créditos",
      g3Intro: "Dimitra usa un sistema basado en créditos para gestionar el consumo de recursos de IA. Los créditos actúan como moneda para generar informes.",
      g3Points: [
        "Asignación: Su cooperativa recibe un saldo mensual de su administrador.",
        "Consumo: Cada vez que genera un informe, se deducen créditos de su saldo disponible.",
        "Visibilidad: Puede seguir cada deducción en su libro de créditos dedicado.",
      ],
      g4Title: "Supervisión del uso e historial de créditos",
      g4Intro: "Mantenga el control de su presupuesto siguiendo de cerca el historial de créditos.",
      g4Points: [
        "Saldo disponible: Siempre visible en la tarjeta superior derecha. Preste atención a la fecha de renovación para saber cuándo llega la próxima asignación.",
        "Registro de uso: Haga clic en [Historial de créditos] para ver un desglose detallado de qué informe se generó, cuándo y por qué entidad (cooperativa, unión, fábrica o agricultor).",
        "Gestión: Si se está quedando sin créditos, use el botón [Administrar informes de IA y créditos] para ajustar los presupuestos por entidad o contacte a su administrador para una recarga adicional.",
      ],
    },
  },
}